import { redIcon } from '../DetailComponents/utils';

export const bachesConfig = {
  id: 'bache',
  label: 'Baches y Pavimento',
  regex: /bache|baches|dan(o|os)/,
  autoHeatmap: true,
  icon: redIcon,
  jsonFields: [
    { key: 'tipo_bache', label: 'Tipo de Bache' },
    { key: 'profundidad', label: 'Profundidad (cm)' },
    { key: 'tamano', label: 'Tamaño' },
    { key: 'peligroso', label: 'Peligroso', type: 'bool' },
    { key: 'requiere_reparacion', label: 'Requiere Reparación', type: 'bool' },
  ],
  subFilters: [],
  calculatePriority: () => 'Baja', // Default por ahora
  calculateCompany: () => 'N/A',
  summaryConfig: {
    showCompanyKPI: false,
    showPriorityKPI: false,
    mainChart: 'streets'
  },
  hasPriority: false,
  hasCompany: false,
  renderExtraInfo: () => null
};
